/* Shared helpers/colors for the Clinical Operations Workspace. */
import {
  Activity, AlertTriangle, BellRing, BadgeCheck, Phone, Brain, Video,
  Stethoscope, ClipboardCheck, MapPin, HeartPulse, ClipboardList, Pill,
} from "lucide-react";

export const RISK_BADGE = {
  critical: { bg: "#FEE2E2", text: "#991B1B", label: "Critical" },
  high: { bg: "#FED7AA", text: "#9A3412", label: "High" },
  moderate: { bg: "#FEF3C7", text: "#92400E", label: "Moderate" },
  stable: { bg: "#D1FAE5", text: "#065F46", label: "Stable" },
  null: { bg: "#F1F5F9", text: "#475569", label: "—" },
};

export const TASK_SOURCE_META = {
  rpm: { label: "RPM", icon: Activity, color: "#8B5CF6" },
  hotline: { label: "Hotline", icon: Phone, color: "#F59E0B" },
  teleconsult: { label: "Teleconsult", icon: Video, color: "#0B7E8C" },
  home_visit: { label: "Home Visit", icon: MapPin, color: "#10B981" },
  order: { label: "Order", icon: ClipboardList, color: "#3B82F6" },
  mar: { label: "MAR", icon: Pill, color: "#EF4444" },
};

export const PRIORITY_BADGE = {
  critical: { bg: "#FEE2E2", text: "#991B1B" },
  urgent: { bg: "#FED7AA", text: "#9A3412" },
  high: { bg: "#FEF3C7", text: "#92400E" },
  medium: { bg: "#DBEAFE", text: "#1E40AF" },
  routine: { bg: "#F1F5F9", text: "#475569" },
  low: { bg: "#F1F5F9", text: "#475569" },
};

export const VITAL_SHORT = {
  bp_systolic: "BP", heart_rate: "HR",
  spo2: "SpO2", temperature: "Temp",
  respiratory_rate: "RR",
};

export const READING_STATUS_BADGE = {
  amber: { bg: "#FEF3C7", text: "#92400E" },
  red: { bg: "#FEE2E2", text: "#991B1B" },
  critical: { bg: "#FEE2E2", text: "#7F1D1D" },
  missing: { bg: "#F1F5F9", text: "#475569" },
  normal: { bg: "#D1FAE5", text: "#065F46" },
};

export function timeAgo(iso) {
  if (!iso) return "—";
  const ms = Date.now() - new Date(iso).getTime();
  if (ms < 60000) return "just now";
  const m = Math.floor(ms / 60000);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  return `${Math.floor(h / 24)}d ago`;
}

export const ICONS = { AlertTriangle, BellRing, BadgeCheck, Brain, Stethoscope, ClipboardCheck, HeartPulse };
